function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-file-upload",
  d: "M6 19.5h9v-9h6L10.5 0 0 10.5h6zm-6 3h21v3H0z",
  fill: "#3c00dc"
});

function SvgUploadinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25.5,
    viewBox: "0 0 21 25.5"
  }, props), _ref);
}

export default SvgUploadinline;